import React from 'react'
import { CommonBorderGroupProps } from './types'
import { BorderType } from 'common/types/styleTypes'
import { useUpdateStoreObject } from '../../../hooks/use-update-store'
import { BorderStyleControl } from '../../controls/border-style-control'
import { BorderTypeControl } from '../../controls/border-type-control'
import { getMobileOrDesktop } from 'src/shared/utils/get-mobile-or-desktop'
import { useDeviceModeContext } from 'client/context/DeviceModeContext'
import { BorderWidthControl } from '../../controls/border-width-control'

type StylesObjectExtend = {
  border: Partial<BorderType>
  mobileBorder?: Partial<BorderType>
}

type UpdateBorderAction<BorderObject extends Partial<BorderType>> = (
  border: BorderObject,
) => {
  type: string
  payload: BorderObject
}

interface WebsiteBorderGroupProps<StylesObject extends StylesObjectExtend>
  extends CommonBorderGroupProps {
  stylesObject: StylesObject
  updateBorderAction: UpdateBorderAction<Partial<BorderType>>
  mobileUpdateBorderAction?: UpdateBorderAction<Partial<BorderType>>
}

export const WebsiteBorderGroup = <StylesObject extends StylesObjectExtend>({
  stylesObject,
  updateBorderAction,
  mobileUpdateBorderAction,
  calculateValuesHook,
}: WebsiteBorderGroupProps<StylesObject>) => {
  const update = useUpdateStoreObject(updateBorderAction)
  const mobileUpdate = mobileUpdateBorderAction
    ? useUpdateStoreObject(mobileUpdateBorderAction)
    : undefined
  const { isMobile } = useDeviceModeContext()

  const { calculatedBorder } = calculateValuesHook
    ? calculateValuesHook({
        border: stylesObject.border,
        mobileBorder: stylesObject.mobileBorder,
      })
    : {
        calculatedBorder: getMobileOrDesktop(
          stylesObject?.border,
          stylesObject?.mobileBorder,
          isMobile,
        ),
      }

  return (
    <>
      <BorderTypeControl
        border={calculatedBorder}
        update={update}
        mobileUpdate={mobileUpdate}
      />
      <BorderStyleControl
        border={calculatedBorder}
        update={update}
        mobileUpdate={mobileUpdate}
      />
      <BorderWidthControl
        border={calculatedBorder}
        update={update}
        mobileUpdate={mobileUpdate}
      />
    </>
  )
}
